import { schema } from "normalizr";

const brandSchema = new schema.Entity("brands");
const brandsSchema = new schema.Array(brandSchema);
const dataSpeedGenSchema = new schema.Entity("dataSpeedGens");
const dataSpeedGensSchema = new schema.Array(dataSpeedGenSchema);
const offerExtraGroupSchema = new schema.Entity("offerExtraGroups");
const offerExtraGroupsSchema = new schema.Array(offerExtraGroupSchema);
const offerExtraSchema = new schema.Entity("offerExtras");
const offerExtrasSchema = new schema.Array(offerExtraSchema);
const phoneCategorySchema = new schema.Entity("phoneCategories");
const phoneCategoriesSchema = new schema.Array(phoneCategorySchema);
const phoneOperatingSystemSchema = new schema.Entity("phoneOperatingSystems");
const phoneOperatingSystemsSchema = new schema.Array(
  phoneOperatingSystemSchema
);
const phoneSchema = new schema.Entity("phones");
const phonesSchema = new schema.Array(phoneSchema);
const phoneStateSchema = new schema.Entity("phoneStates");
const phoneStatesSchema = new schema.Array(phoneStateSchema);
const phoneVariantSchema = new schema.Entity("phoneVariants");
const phoneVariantsSchema = new schema.Array(phoneVariantSchema);
const providerSchema = new schema.Entity("providers");
const providersSchema = new schema.Array(providerSchema);
const shopSchema = new schema.Entity("shops");
const shopsSchema = new schema.Array(shopSchema);

export {
  brandSchema,
  brandsSchema,
  dataSpeedGenSchema,
  dataSpeedGensSchema,
  offerExtraGroupSchema,
  offerExtraGroupsSchema,
  offerExtraSchema,
  offerExtrasSchema,
  phoneCategorySchema,
  phoneCategoriesSchema,
  phoneOperatingSystemSchema,
  phoneOperatingSystemsSchema,
  phoneSchema,
  phonesSchema,
  phoneStateSchema,
  phoneStatesSchema,
  phoneVariantSchema,
  phoneVariantsSchema,
  providerSchema,
  providersSchema,
  shopSchema,
  shopsSchema
};
